import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AnonymousModalUpgrades = styled.div<React.CSSProperties>`
  bottom: ${300 * Screen.widthRatio}px;
  display: flex;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  width: fit-content;
  z-index: 1;
`;

export default AnonymousModalUpgrades;
